/**
 * CalendarEvent Component
 *
 * Displays a post event on the calendar with status-based styling
 */

import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";

function CalendarEvent({ event }) {
  const getStatusColor = (status) => {
    switch (status) {
      case "Posted":
        return "success";
      case "Pending Approval":
      case "Good to go":
        return "warning";
      case "Rejected":
        return "error";
      default:
        return "info";
    }
  };

  return (
    <MDBox
      sx={{
        padding: "2px 6px",
        borderRadius: "4px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        cursor: "pointer",
        "&:hover": {
          opacity: 0.8,
        },
      }}
    >
      <MDTypography
        variant="caption"
        fontWeight="medium"
        sx={{
          fontSize: "0.7rem",
          lineHeight: 1.2,
          display: "block",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {event.title}
      </MDTypography>
      <MDBadge
        badgeContent={event.status}
        color={getStatusColor(event.status)}
        size="xs"
        sx={{ mt: 0.25 }}
      />
    </MDBox>
  );
}

CalendarEvent.propTypes = {
  event: PropTypes.shape({
    title: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
  }).isRequired,
};

export default CalendarEvent;
